module.exports = __webpack_public_path__ + "img/main_middle.7b8ae10b.png";